/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Card, Image, Typography, H2, Loader } from '../../components';
import isLoadingSelector from '../../lib/redux/selectors/app/is-loading';
import AvailableIllustration from '../../assets/images/illustrations/available-calls.svg';
import { BackHomeButton } from '../../components/BackHomeButton';
import { JobBanner } from '../../components/JobBanner';
import { useTimer } from '../../lib/hooks';
import { gotoDashboard as gotoDashboardAction } from '../../lib/redux/actions/dashboard';
import { setAppNotification as setAppNotificationAction } from '../../lib/redux/actions/app';

const WaitingWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const LoaderWrapper = styled.div`
  margin-top: 160px;
`;

export function Waiting({ history, isLoading, gotoDashboard, setAppNotification }) {
  const { isTimerFinished, clearTimerStorage } = useTimer();

  const backButtonHandler = () => {
    clearTimerStorage();
    gotoDashboard(history);
  };

  useEffect(() => {
    if (isTimerFinished) {
      setAppNotification(
        'No customers are available right now. Please try again later or choose another job.'
      );

      gotoDashboard(history);
    }
  }, [isTimerFinished]);

  useEffect(() => {
    setAppNotification(null);
  }, []);

  if (isLoading) {
    return (
      <WaitingWrapper>
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      </WaitingWrapper>
    );
  }

  return (
    <WaitingWrapper>
      <JobBanner />
      <BackHomeButton
        onClick={() => {
          backButtonHandler();
        }}
      />
      <Card backgroundColor="transparent">
        <Image margin="large" src={AvailableIllustration} />

        <H2 fontWeight={700} margin={{ bottom: 'xs' }}>
          There are no customers currently available
        </H2>

        <Typography>
          It can take some time for customers to enter the queue.
          <br />
          If there are no customers after <strong>10 minutes</strong> you'll be redirected to the
          dashboard.
        </Typography>
      </Card>
    </WaitingWrapper>
  );
}

Waiting.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  gotoDashboard: PropTypes.func.isRequired,
  setAppNotification: PropTypes.func.isRequired
};

export default compose(
  withRouter,
  connect(
    state => ({
      isAvailable: state.me.isAvailable,
      isLoading: isLoadingSelector(state)
    }),
    {
      gotoDashboard: gotoDashboardAction,
      setAppNotification: setAppNotificationAction
    }
  )
)(Waiting);
